"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("underscore");
function parseCookie(cookieText) {
    var decoded = decodeURIComponent(cookieText);
    return _.object(decoded.split(/;\s?/).map(function (x) { return x.split('='); }));
}
exports.parseCookie = parseCookie;
//# sourceMappingURL=parse-cookie.js.map